import actions from './actions';
import { createReducer } from '../../../../../helpers/reducer';

const initState = {
  talentReferrals: null,
  talentReferralsSearch: '',
  talentReferralsPage: 1,
  talentReferralsItemsOnPage: 10,
  talentReferralsFormData: null,
  talentReferralsFormSearch: '',
  formDateSelectItem: undefined,
  isModalVisible: false,
  loading: false,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadFormDataSuccess(state, { payload }) {
  const { data } = payload;
  const talentReferralsFormData = data;

  return {
    ...state,
    talentReferralsFormData,
    loading: false,
  };
}

function onToggleModal(state) {
  return {
    ...state,
    formDateSelectItem: state.isModalVisible ? undefined : state.formDateSelectItem,
    isModalVisible: !state.isModalVisible,
  };
}

function onChangeFormDateSelectItem(state, { payload }) {
  return {
    ...state,
    formDateSelectItem: payload,
  };
}

function onChangeSearch(state, { payload }) {
  return {
    ...state,
    talentReferralsFormSearch: payload,
  };
}

function onLoadFormData(state) {
  return {
    ...state,
    loading: true,
  };
}

function onChangeFilteredParams(state, { payload }) {
  return {
    ...state,
    talentReferralsSearch: payload.filter,
    talentReferralsPage: payload.page,
    talentReferralsItemsOnPage: +payload.pageSize,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data } = payload;
  const { referrer, referrals } = data;

  return {
    ...state,
    talentReferrals: referrals,
    referrer,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.LOAD_FORM_DATA]: onLoadFormData,
  [actions.LOAD_FORM_DATA_SUCCESS]: onLoadFormDataSuccess,
  [actions.TOGGLE_MODAL]: onToggleModal,
  [actions.CHANGE_SEARCH]: onChangeSearch,
  [actions.CHANGE_FILTERED_PARAMS]: onChangeFilteredParams,
  [actions.FORM_DATA_SELECT_ITEM]: onChangeFormDateSelectItem,
  [actions.CLEAR_STORE]: onClearStore,
});
